import api, {
  MutationRequestOptions,
  getMutationRequestConfig,
} from '../utils/axiosConfig';
import type {
  MenderConfigStatus,
  MenderConfigUpdate,
  MenderConnectionTestResponse,
} from '../types/device-upgrade';

export const getMenderConfigStatus = async (): Promise<MenderConfigStatus> => {
  const response = await api.get('/operations/mender/status');
  return response.data;
};

export const updateMenderConfig = async (
  payload: MenderConfigUpdate,
  options?: MutationRequestOptions,
): Promise<MenderConfigStatus> => {
  const response = await api.put(
    '/operations/mender/config',
    payload,
    getMutationRequestConfig(options),
  );
  return response.data;
};

export const testMenderConnection = async (
  options?: MutationRequestOptions,
): Promise<MenderConnectionTestResponse> => {
  const response = await api.post(
    '/operations/mender/test-connection',
    undefined,
    getMutationRequestConfig(options),
  );
  return response.data;
};
